import { render, staticRenderFns } from "./detailTabs.vue?vue&type=template&id=313bb974&scoped=true"
import script from "./detailTabs.vue?vue&type=script&lang=js"
export * from "./detailTabs.vue?vue&type=script&lang=js"
import style0 from "./detailTabs.vue?vue&type=style&index=0&id=313bb974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313bb974",
  null
  
)

export default component.exports